import React from "react";
import { Link, NavLink } from "react-router-dom";
import mockqLogo from "../images/mockq-logo-dark.png"; // blue MockQ logo (transparent background)

export const NAV_ITEMS = [
  { to: "/profile", label: "Profile", tag: "A1", icon: "bi-person-circle" },
  { to: "/scoreboard", label: "Score Board", tag: "A2", icon: "bi-bar-chart-line" },
  { to: "/purchases", label: "Purchase", tag: "A3", icon: "bi-cart3" },
];

export default function AppSidebar() {
  return (
    <aside className="oes-home-sidenav">
      <div className="oes-home-brand oes-home-brand-has-logo">
        <Link
          to="/home"
          className="oes-home-brand-link"
          aria-label="MockQ student home"
        >
          <img
            src={mockqLogo}
            alt="MockQ"
            className="oes-home-brand-logo"
            draggable="false"
          />
        </Link>
        <div className="oes-home-brand-text">
          <small>Student Portal</small>
        </div>
      </div>

      <nav className="oes-home-nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            to={item.to}
            className={({ isActive }) =>
              `oes-home-navitem${isActive ? " active" : ""}`
            }
            key={item.to}
            title={item.label}
          >
            <span className="oes-home-navitem-icon">
              <i className={`bi ${item.icon}`} />
            </span>
            <span className="oes-home-navitem-text">{item.label}</span>
            <span className="oes-home-navitem-label">{item.tag}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}